import React from 'react';

import Utils from 'utils/Utils';

import useStyles from './styles';

interface Props {
    type: string;
    name: string;
    count: number;
    className?: string;
}

const BulletinWidget: React.FC<Props> = ({ type, name, count, className }) => {
    const { classes, cx } = useStyles();

    return (
        <div className={cx(classes.container, className)}>
            <img width={48} height={48} className={classes.image} src={Utils.getImage(type)} alt={type} />
            <div className={classes.info}>
                <a href={'/search/types/' + type}>
                    <span className={classes.name}>{name}</span>
                </a>
                <span className={classes.count}>{`${count} entries`}</span>
            </div>
        </div>
    );
};

export default BulletinWidget;
